export const area = {
    "area": "Áreas",
    "informationCard": {
      "create": "Nueva área",
      "edit": "Editar área",
      "buttons": {
        "add": "Agregar área",
        "update": "Actualizar área",
        "cancel": "Cancelar",
        "edit": "Editar área"
      }
    },
    "snackbar": {
      "create": {
        "success": "El área se creó exitosamente",
        "error": "Ocurrió un error al crear el área"
      },
      "update": {
        "success": "El área se actualizó exitosamente",
        "error": "Ocurrió un error al actualizar el área"
      },
      "delete": {
        "success": "El área se eliminó exitosamente",
        "error": "Ocurrió un error al eliminar el área",
        "errorCode": {
          "ERR_DELETE_QUESTIONNAIRE_MAIN": "No se puede eliminar el área, porque se encuentra asociada a un cuestionario principal"
        }
      }
    },
    "modal": {
      "delete": {
        "title": "¿Está seguro que desea eliminar esta área?",
        "description": "",
        "error": "Ocurrió un error al eliminar el área",
        "success": "El área se eliminó exitosamente"
      }
    }
  }